var $260cc0fc04d161dd$exports = {};
$260cc0fc04d161dd$exports = {
    "decrease": (args)=>`Reducir ${args.fieldLabel}`,
    "increase": (args)=>`Aumentar ${args.fieldLabel}`,
    "numberField": `Campo de n\xfamero`
};


export {$260cc0fc04d161dd$exports as default};
//# sourceMappingURL=es-ES.mjs.map
